// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"xC-z","expressButtonContainerWithPayPal":"yC-z","expressButton":"zC-z","or":"AC-z"};